import { CultureInfo } from '../culture-info.model';
import { CultureInfoZhHant } from './zh-Hant';

/**
 * @ignore
 */
export const CultureInfoZhHantTW: CultureInfo = {
  name: 'zh-Hant-TW',
  displayName: '繁體中文（台灣）',
  iso3LanguageCode: 'zho',
  iso2LanguageCode: 'zh',
  ietfLanguageTag: 'zh-Hant-TW',
  parent: CultureInfoZhHant
};
